import 'intersection-observer'

export default class LazyObserver{
	constructor({threshold = 0, root} = {}) {
		this.subs = new Map()
		this.config = {threshold, root}
		this.io = this.init()
	}
	
	init(){
		const io = new IntersectionObserver(entries => {
			entries.forEach(entrie => {
				const {target, isIntersecting} = entrie
				if(isIntersecting){
					const id = target.id
					const watcher = this.subs.get(id)
					watcher.render() // 注意this
					this.unobserve(watcher.el, id)
					if(this.viewport){
						this.viewport.refresh()
					}
				}
			})
		}, this.config)
		return io
	}
	
	observe(watcher){
		const {id, el} = watcher
		this.subs.set(id, watcher)
		this.io.observe(el)
	}
	
	unobserve(el, id){
		this.io.unobserve(el)
		this.subs.delete(id)
	}
	
	disconnect(){
		this.io.disconnect()
	}
}

export class Watcher{
	constructor(el, render, dist) {
	    this.el = el
		this.id = el.id
		this.render = render
		this.dist = dist
	}
}